export default {
  popular_products: "Popular products",
  show_more_popular: "Show more products",
  show_product: "Show product",
  favorite_products: "Our favorites"
}
